import { environment } from './environments/environment';
import { initializeTracing } from './tracing-setup';

initializeTracing(environment);
